// IMG
import imgPillow1 from '../assets/Mobile/pillow1.jpg';
import imgPillow2 from '../assets/Mobile/pillow2.jpg';
import imgPillow3 from '../assets/Mobile/pillow3.jpg';
import imgPillow4 from '../assets/Mobile/pillow4.jpg';
import imgPillow5 from '../assets/Mobile/pillow5.jpg';
import imgCandle2 from '../assets/Mobile/candle2.jpg';
import imgCandle4 from '../assets/Mobile/candle4.jpg';
import imgCandle7 from '../assets/Mobile/candle7.jpg';
import imgCandle8 from '../assets/Mobile/candle8.jpg';
import imgMug2 from '../assets/Mobile/mug2.jpg';
import imgMug3 from '../assets/Mobile/mug3.jpg';
import imgMug4 from '../assets//Mobile/mug4.jpg';
import imgMug7 from '../assets/Mobile/mug7.jpg';

export const data = [
	{
		id: 0,
		status: false,
		statusFont: 'normal',
		title: `poduszka żółta niebieska`,
		shortContent: `poduszka na jesień`,
		content: `Ceramiczny kubek ze złotymi elementami. Poręczne ucho gwarantuje stabilny uchwyt podczas picia gorącego napoju. Proste kształty, stonowane kolory i matowa emalia nadają stołowi rustykalny charakter.`,
		price: 9.99,
		newPrice: false, //priceSale
		imgSmall: `${imgPillow1}`,
		imgLarge: `${imgPillow1}`,
		category: 'bedroom',
		fav: false,
		amount: 0,
		cart: false,
	},
	{
		id: 1,
		status: false,
		statusFont: 'normal',
		title: `poduszka serce walentynki`,
		shortContent: `poduszka serce walentynki`,
		content: `Ceramiczny kubek ze złotymi elementami. Poręczne ucho gwarantuje stabilny uchwyt podczas picia gorącego napoju. Proste kształty, stonowane kolory i matowa emalia nadają stołowi rustykalny charakter.`,
		price: 33.99,
		newPrice: false,
		imgSmall: `${imgPillow2}`,
		imgLarge: `${imgPillow2}`,
		category: 'bedroom',
		fav: false,
		amount: 0,
		cart: false,
	},
	{
		id: 2,
		status: `hit`,
		statusFont: 'normal',
		title: `komplet poduszek beżowych`,
		shortContent: `Komplet poduszek beżowych`,
		content: `Ceramiczny kubek ze złotymi elementami. Poręczne ucho gwarantuje stabilny uchwyt podczas picia gorącego napoju. Proste kształty, stonowane kolory i matowa emalia nadają stołowi rustykalny charakter.`,
		price: 104.99,
		newPrice: false,
		imgSmall: `${imgPillow3}`,
		imgLarge: `${imgPillow3}`,
		category: 'bedroom',
		fav: false,
		amount: 0,
		cart: false,
	},
	{
		id: 3,
		status: false,
		statusFont: 'normal',
		title: `zestaw czarno-biały`,
		shortContent: `Komplet poduszek beżowych`,
		content: `Ceramiczny kubek ze złotymi elementami. Poręczne ucho gwarantuje stabilny uchwyt podczas picia gorącego napoju. Proste kształty, stonowane kolory i matowa emalia nadają stołowi rustykalny charakter.`,
		price: 49.99,
		newPrice: false,
		imgSmall: `${imgPillow4}`,
		imgLarge: `${imgPillow4}`,
		category: 'bedroom',
		fav: false,
		amount: 0,
		cart: false,
	},
	{
		id: 4,
		status: 'wyprzedaz',
		statusFont: 'through',
		title: `komplet poduszek kolorowe`,
		shortContent: `Komplet poduszek kolorowe`,
		content: `Ceramiczny kubek ze złotymi elementami. Poręczne ucho gwarantuje stabilny uchwyt podczas picia gorącego napoju. Proste kształty, stonowane kolory i matowa emalia nadają stołowi rustykalny charakter.`,
		price: 129.99,
		newPrice: 99.78,
		imgSmall: `${imgPillow5}`,
		imgLarge: `${imgPillow5}`,
		category: 'bedroom',
		fav: false,
		amount: 0,
		cart: false,
	},
	{
		id: 5,
		status: 'hit',
		statusFont: 'normal',
		title: `świeczka kwiat`,
		shortContent: `Świeczka kwiat`,
		content: `Ceramiczny kubek ze złotymi elementami. Poręczne ucho gwarantuje stabilny uchwyt podczas picia gorącego napoju. Proste kształty, stonowane kolory i matowa emalia nadają stołowi rustykalny charakter.`,
		price: 29.99,
		newPrice: false,
		imgSmall: `${imgCandle2}`,
		imgLarge: `${imgCandle2}`,
		category: 'livingroom',
		fav: false,
		amount: 0,
		cart: false,
	},
	{
		id: 6,
		status: `wyprzedaz`,
		statusFont: 'through',
		title: `zestaw świec z gwiazdą`,
		shortContent: `Zestaw świec z gwiazdą`,
		content: `Ceramiczny kubek ze złotymi elementami. Poręczne ucho gwarantuje stabilny uchwyt podczas picia gorącego napoju. Proste kształty, stonowane kolory i matowa emalia nadają stołowi rustykalny charakter.`,
		price: 19.99,
		newPrice: 14.99,
		imgSmall: `${imgCandle4}`,
		imgLarge: `${imgCandle4}`,
		category: 'livingroom',
		fav: false,
		amount: 0,
		cart: false,
	},
	{
		id: 7,
		status: false,
		statusFont: 'normal',
		title: `świeczki losowe kolory`,
		shortContent: `Świeczki losowe kolory`,
		content: `Ceramiczny kubek ze złotymi elementami. Poręczne ucho gwarantuje stabilny uchwyt podczas picia gorącego napoju. Proste kształty, stonowane kolory i matowa emalia nadają stołowi rustykalny charakter.`,
		price: 3.99,
		newPrice: false,
		imgSmall: `${imgCandle7}`,
		imgLarge: `${imgCandle7}`,
		category: 'livingroom',
		fav: false,
		amount: 0,
		cart: false,
	},
	{
		id: 8,
		status: `hit`,
		statusFont: 'normal',
		title: `duża świeczka różana`,
		shortContent: `Zestaw świec z gwiazdą`,
		content: `Ceramiczny kubek ze złotymi elementami. Poręczne ucho gwarantuje stabilny uchwyt podczas picia gorącego napoju.`,
		price: 34.99,
		newPrice: false,
		imgSmall: `${imgCandle8}`,
		imgLarge: `${imgCandle8}`,
		category: 'livingroom',
		fav: false,
		amount: 0,
		cart: false,
	},
	{
		id: 9,
		status: `hit`,
		statusFont: 'normal',
		title: `turkusowy kubek`,
		shortContent: `Turkusowy kubek`,
		content: `Ceramiczny kubek ze złotymi elementami. Poręczne ucho gwarantuje stabilny uchwyt podczas picia gorącego napoju. Proste kształty, stonowane kolory i matowa emalia nadają stołowi rustykalny charakter.`,
		price: 19.99,
		newPrice: false,
		imgSmall: `${imgMug2}`,
		imgLarge: `${imgMug2}`,
		category: `kitchen`,
		fav: false,
		amount: 0,
		cart: false,
	},
	{
		id: 10,
		status: `wyprzedaz`,
		statusFont: 'through',
		title: `beżowy kubek serce`,
		shortContent: `Beżowy kubek serce`,
		content: `Ceramiczny kubek ze złotymi elementami. Poręczne ucho gwarantuje stabilny uchwyt podczas picia gorącego napoju. Proste kształty, stonowane kolory i matowa emalia nadają stołowi rustykalny charakter.`,
		price: 24.99,
		newPrice: 21.99,
		imgSmall: `${imgMug3}`,
		imgLarge: `${imgMug3}`,
		category: `kitchen`,
		fav: false,
		amount: 0,
		cart: false,
	},
	{
		id: 11,
		status: false,
		statusFont: 'normal',
		title: `coffe saves kubek`,
		shortContent: `coffe saves kubek`,
		content: `Ceramiczny kubek ze złotymi elementami. Poręczne ucho gwarantuje stabilny uchwyt podczas picia gorącego napoju. Proste kształty, stonowane kolory i matowa emalia nadają stołowi rustykalny charakter.`,
		price: 14.99,
		newPrice: false,
		imgSmall: `${imgMug4}`,
		imgLarge: `${imgMug4}`,
		category: `kitchen`,
		fav: false,
		amount: 0,
		cart: false,
	},
	{
		id: 12,
		status: `wyprzedaz`,
		statusFont: 'through',
		title: `brązowy matowy kubek`,
		shortContent: `Brązowy matowy kubek`,
		content: `Ceramiczny kubek ze złotymi elementami. Poręczne ucho gwarantuje stabilny uchwyt podczas picia gorącego napoju. Proste kształty, stonowane kolory i matowa emalia nadają stołowi rustykalny charakter.`,
		price: 17.99,
		newPrice: 14.99,
		imgSmall: `${imgMug7}`,
		imgLarge: `${imgMug7}`,
		category: `kitchen`,
		fav: false,
		amount: 0,
		cart: false,
	},
];
